import { GetTaskId } from "../util/UrlUtil";
import { GetTaskCardInfo } from "./api/TaskInfoApiClient";

const RECENT_TASK_GROUP_ID = "recent_task_group";
const RECENT_TASK_GROUP_METHOD = "recent_task_group_method";

export function SaveMostRecentTaskGroup(groupId: string, groupMethod: number) {
    window.localStorage[RECENT_TASK_GROUP_ID] = groupId;
    window.localStorage[RECENT_TASK_GROUP_METHOD] = groupMethod;
}

export async function GetMostRecentTaskGroup(): Promise<string> {
    var result = window.localStorage[RECENT_TASK_GROUP_ID];
    if(result) {
        return result;
    }
    else {
        return await GetTaskGroupFallback(GetTaskId());
    }
}

export async function GetTaskGroupFallback(taskId: string): Promise<string> {
    let cardInfo = await GetTaskCardInfo(taskId)
    return cardInfo.workItemGuid;
}